import { connect } from 'react-redux';
import DesignReadyPage from './DesignReadyPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getDesignReadyOrderData } from 'src/actions/manufacturAction';
// import { push } from 'react-router-redux';
// import {
//     saveFeedbackType,
//     saveCommands,
//     doFeedback
// } from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
    return {
        designReadyData: state.manufactur.designReadyData,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
        orderDataTat: state.fileUpload.orderDataTat
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getCompleteOrderData);
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getDesignReadyOrderData);
        },
        reload: () => {
            dispatch(getDesignReadyOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'mdesignready'));
        },
        dateFilter: () => {
            dispatch(getDesignReadyOrderData);
        },
        dateReset: () => {
            dispatch(getDesignReadyOrderData);
        }
    };
};

const DesignReadyContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesignReadyPage);

export default DesignReadyContainer;



// WEBPACK FOOTER //
// ./src/components/DesignReady/DesignReadyContainer.tsx